import { CustomSelectOption } from '@/components/CustomSelect/CustomSelectModel';
import { IInternationalization } from '@/models/internationalization';

export class PersonalInformation {
  constructor(
    public userName?: string,
    public email?: string,
    public password?: string
  ) {}
  [key: string]: any;
}

export class CoinInformation {
  constructor(
    public coinPerDollar?: string,
    public percentage?: string,
    public imagePreview?: string
  ) {}
}

export class BusinessInformation {
  constructor(
    public bussinesName?: string,
    public logoId?: string,
    public address?: string,
    public secondAddress?: string,
    public type?: string,
    public city?: string,
    public state?: string,
    public postalCode?: string,
    public phoneNumber?: string,
    public categoryId?: CustomSelectOption
  ) {}
  [key: string]: any;
}

export class userState {
  constructor(
    public coinInformation: CoinInformation = new CoinInformation(),
    public personalInformation?: PersonalInformation,
    public businessInformation?: BusinessInformation,
    public businessCountry?: IInternationalization
  ) {}
}
